export interface MarkOutsideProcessContractMovementsAsSentDto {
	dateSent: Date;
	outsideProcessContractMovementIds: number[];
	siteId: number;
}

export class MarkOutsideProcessContractMovementsAsSentDto implements MarkOutsideProcessContractMovementsAsSentDto {
	constructor(data?: Partial<MarkOutsideProcessContractMovementsAsSentDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}